<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div v-show="stateArrow" id="leftBox" class="leftBox" style="width: 160px">
          <vue-draggable-resizable :min-width="140" @resizing="onResize" :max-width="400" :draggable="false"
            :handles="['mr']" :w="160" :parent="false">
            <el-scrollbar>
              <tree :isSearch="isSearch" @initFun="initQuery" @nodeClick="nodeClick"></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form" style="margin-bottom: 10px;">
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                  <el-form-item :label="$t('common.num')">
                    <el-select v-model="formInline.selectCarType" style="width: 120px"
                      :placeholder="$t('common.form.choseTip')" class="selectStyle">
                      <el-option v-for="item in optionsInput" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                    <el-input size="mini" v-model="formInline.selectCarValue" :placeholder="$t('common.searchTip')"
                      style="width: 150px" class="inputStyle"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('common.terminalId')">
                    <el-input size="mini" v-model="formInline.terminalId" :placeholder="$t('common.searchTip')"
                      style="width: 150px" class="input-with-select"></el-input>
                  </el-form-item>
                  <!-- <el-form-item :label="$t('common.choseTime')">
                    <el-date-picker v-model="formInline.FactoryTime" type="daterange" style="width: 220px" size="mini"
                      value-format="yyyy-MM-dd" range-separator :start-placeholder="$t('common.choseTime')"
                      end-placeholder></el-date-picker>
                  </el-form-item> -->
                  <el-form-item>
                    <el-button size="mini" type="primary" @click="onSearch" class="btn-chaxun">{{
                      $t("common.btn.search") }}</el-button>
                    <el-button size="mini" @click="onClear" class="btn-del">{{
                      $t("common.btn.cancel")
                    }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <i-table :list="list" :height="height" ref="carTable" :options="option" :columns="columns"
                :operates="operates"></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog width="80%" :before-close="closeDia" class="carDialong" :title="diaTitle"
        :visible.sync="dialogFormVisible" :close-on-click-modal="false">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="DMS摄像头" name="1"></el-tab-pane>
          <el-tab-pane label="前摄像头" name="2"></el-tab-pane>
          <el-tab-pane label="后摄像头" name="3"></el-tab-pane>
          <el-tab-pane label="左摄像头" name="4"></el-tab-pane>
          <el-tab-pane label="右摄像头" name="5"></el-tab-pane>
        </el-tabs>
        <div class="video-container">
          <div class="video-player-wrapper" @mouseenter="showPlayButton = true" @mouseleave="showPlayButton = false">
            <!-- 视频容器：仅用于被 innerHTML 注入 video 元素，不要放 Vue 渲染的按钮 -->
            <div id="video-player-container" class="video-player-inner"></div>
            <!-- 播放前的遮罩层（未播放时始终显示） -->
            <div v-if="!isPlaying" class="video-mask" @click="startPlayVideo">
              <div class="play-button">
                <i class="el-icon-video-play"></i>
              </div>
            </div>
            <!-- 播放中鼠标悬停显示的播放/暂停按钮（按钮显示当前状态：播放中显示播放按钮，暂停时显示暂停按钮） -->
            <div v-if="isPlaying && showPlayButton" class="video-control-overlay" @click="togglePlayPause">
              <div class="control-button">
                <i :class="isPaused ? 'el-icon-video-pause' : 'el-icon-video-play'"></i>
              </div>
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitForm">{{
            $t("common.btn.confirm")
          }}</el-button>
        </div>
      </el-dialog>
      
      <!-- 历史视频弹框 -->
      <HistoryVideoDialog 
        :visible.sync="historyVideoDialogVisible"
        :currentCarInfo="currentCarInfo"
      ></HistoryVideoDialog>
    </div>
  </div>
</template>

<script>
import VideoPreview from "./VideoPreview.js";
import HistoryVideoDialog from "./HistoryVideoDialog.vue";

export default {
  ...VideoPreview,
  components: {
    ...VideoPreview.components,
    HistoryVideoDialog
  }
};
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";

.video-container {
  width: 100%;
  height: 500px;
  background-color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  
  .video-player-wrapper {
    width: 100%;
    height: 100%;
    position: relative;

    .video-player-inner {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;

      video {
        width: 100%;
        height: 100%;
        background: #000;
        object-fit: contain;
      }
    }

    /deep/ .video-js {
      width: 100%;
      height: 100%;

      .vjs-tech {
        width: 100%;
        height: 100%;
      }
    }
    
    .no-video-tip {
      color: #fff;
      font-size: 16px;
      text-align: center;
      line-height: 500px;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 5;
    }
    
    .video-mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.7);
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      z-index: 10;
      
      .play-button {
        width: 80px;
        height: 80px;
        background-color: rgba(255, 255, 255, 0.9);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all 0.3s ease;
        
        i {
          font-size: 40px;
          color: #409EFF;
        }
        
        &:hover {
          background-color: rgba(255, 255, 255, 1);
          transform: scale(1.1);
        }
      }
    }
    
    .video-control-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      z-index: 11;
      
      .control-button {
        width: 60px;
        height: 60px;
        background-color: rgba(255, 255, 255, 0.9);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all 0.3s ease;
        
        i {
          font-size: 30px;
          color: #409EFF;
        }
        
        &:hover {
          background-color: rgba(255, 255, 255, 1);
          transform: scale(1.1);
        }
      }
    }
  }
}
</style>
